import React from 'react';
import PropTypes from 'prop-types';

const ServiceALerts = ({ fill = '' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 16.5751C9.47878 16.5731 9.93737 16.382 10.2759 16.0435C10.6145 15.7049 10.8055 15.2463 10.8075 14.7676H7.1925C7.19448 15.2463 7.38555 15.7049 7.72409 16.0435C8.06264 16.382 8.52123 16.5731 9 16.5751Z"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
    <path
      d="M14.505 11.7444L13.845 11.0769V7.97188C13.9024 6.94244 13.637 5.92077 13.0857 5.04949C12.5344 4.17821 11.7249 3.50082 10.77 3.11188C10.7408 2.66333 10.5419 2.24271 10.2139 1.93538C9.88591 1.62805 9.45324 1.45703 9.00374 1.45703C8.55425 1.45703 8.12158 1.62805 7.79356 1.93538C7.46554 2.24271 7.26674 2.66333 7.23749 3.11188C6.28197 3.49988 5.47175 4.17707 4.92034 5.04857C4.36892 5.92008 4.10394 6.94224 4.1625 7.97188V11.0769L3.495 11.7444C3.29419 11.9432 3.15705 12.1973 3.10101 12.4743C3.04498 12.7514 3.07258 13.0388 3.18031 13.3001C3.28804 13.5613 3.47103 13.7847 3.70602 13.9417C3.941 14.0987 4.21738 14.1823 4.5 14.1819H13.5C13.7817 14.1802 14.0566 14.0956 14.2904 13.9386C14.5242 13.7815 14.7066 13.559 14.8146 13.2989C14.9227 13.0388 14.9516 12.7526 14.8979 12.4761C14.8442 12.1996 14.7101 11.9451 14.5125 11.7444H14.505ZM4.6575 12.6894L5.6475 11.6994V7.94938C5.6475 6.10438 6.60749 4.73188 8.15249 4.36438L8.72249 4.22937C8.90693 4.20888 9.09306 4.20888 9.27749 4.22937L9.855 4.36438C11.355 4.73188 12.3525 6.10438 12.3525 7.94938V11.6994L13.3425 12.6894H4.6575Z"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.71151 1.76303C5.8425 2.15599 5.63013 2.58073 5.23717 2.71172C4.50315 2.95639 2.75 4.16354 2.75 7.0002C2.75 7.41442 2.41421 7.7502 2 7.7502C1.58579 7.7502 1.25 7.41442 1.25 7.0002C1.25 3.43687 3.49685 1.71069 4.76283 1.28869C5.15579 1.15771 5.58053 1.37008 5.71151 1.76303Z"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2885 1.76303C12.1575 2.15599 12.3699 2.58073 12.7628 2.71172C13.4968 2.95639 15.25 4.16354 15.25 7.0002C15.25 7.41442 15.5858 7.7502 16 7.7502C16.4142 7.7502 16.75 7.41442 16.75 7.0002C16.75 3.43687 14.5032 1.71069 13.2372 1.28869C12.8442 1.15771 12.4195 1.37008 12.2885 1.76303Z"
      fill={fill || 'var(--SECONDARY_LIGHT)'}
    />
  </svg>
);

ServiceALerts.propTypes = {
  fill: PropTypes.string,
};

export default ServiceALerts;
